// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import LoginForm from './fragments/loginForm'
import { Logo } from 'src/assets/images'
import { ButtonPrimary, AuthBlock, Loader, LoaderWrapper } from 'src/common/components'
import { StyledLogin } from './loginStyles'
import type { LoginPropsType } from './LoginTypes'
import { StyledEmptyBlock, StyledInfoBlock } from '../myLeagues/leagueManagement/leagueManagementStyles'

const Login = (props: LoginPropsType) => (
  <AuthBlock>
    <LoaderWrapper>
      <Loader show={props.user.isLoading} />
      <StyledLogin>
        <div className="login-header">
          <div className="logo-wrapper">
            <img src={Logo} alt="logo"/>
          </div>
          <StyledInfoBlock>
            <StyledEmptyBlock className="empty-insurance">
              <p className="notification">
                The NFL FLAG website has moved to the supervision of Reigning Champs. If you ordered jerseys in 2019 your account should be active but all passwords have been reset.

                Please go <a href="/forgot-password">HERE</a> to recover your account. If you have any questions please email <a href="mailto:info@nflflag.com">US</a>.

              </p>
            </StyledEmptyBlock>
          </StyledInfoBlock>
        </div>
        <div className="login-body d-flex">
          <div className="body-left">
            <h3>Sign In</h3>
            <LoginForm {...props} />
          </div>
          <div className="body-right">
            <h3>Not Registered Yet?</h3>
            <p>Creating your NFL FLAG account is easy and free! It only takes a few seconds to set up — start your account today!</p>
            <div className="btn-wrapper">
              <Link to="register">
                <ButtonPrimary buttonText="Get Started" size="small"/>
              </Link>
            </div>
          </div>
        </div>
      </StyledLogin>
    </LoaderWrapper>
  </AuthBlock>
)

export default Login
